import { render } from "./SetApprovalRouteSalesNote.vue?vue&type=template&id=5fb270af&scoped=true&ts=true"
import script from "./SetApprovalRouteSalesNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetApprovalRouteSalesNote.vue?vue&type=script&setup=true&lang=ts"

import "./SetApprovalRouteSalesNote.vue?vue&type=style&index=0&id=5fb270af&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb270af"],['__file',"src/components/scan/salesnote/kdp/SetApprovalRouteSalesNote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fb270af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fb270af', __exports__)) {
    console.log('reload')
    api.reload('5fb270af', __exports__)
  }
  
  module.hot.accept("./SetApprovalRouteSalesNote.vue?vue&type=template&id=5fb270af&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5fb270af', render)
  })

}


export default __exports__